import React from "react";
import BaseComponent from "../Base/BaseComponent";

const Box = React.forwardRef((props, ref) => <BaseComponent data-testid={props.testid} ref={ref} {...props} />);

export default Box;
